module.exports = __webpack_public_path__ + "static/media/Jeff.58f68add.png";